(function () {
  if (window.__lrRecentlyViewedSliderInit) return;
  window.__lrRecentlyViewedSliderInit = true;

  const container = document.querySelector('#recently-viewed-container');
  const slider = document.querySelector('#recently-viewed-products');
  const prevBtn = document.querySelector('#recommendedSlidePrev');
  const mobilePrevBtn = document.querySelector('#recommendedSlidePrev-mobile');
  const nextBtn = document.querySelector('#recommendedSlideNext');
  const mobileNextBtn = document.querySelector('#recommendedSlideNext-mobile');

  if (!container || !slider || !prevBtn || !mobilePrevBtn || !nextBtn || !mobileNextBtn) return;

  let scrollAmount = 200;

  function widthChange() {
    if (slider.clientWidth < slider.scrollWidth && window.innerWidth > 990) {
      prevBtn.style.display = 'block';
      nextBtn.style.display = 'block';
      mobilePrevBtn.style.display = 'none';
      mobileNextBtn.style.display = 'none';
    } else if (slider.clientWidth < slider.scrollWidth && window.innerWidth <= 990) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      mobilePrevBtn.style.display = 'block';
      mobileNextBtn.style.display = 'block';
    } else {
      prevBtn.style.display = 'none';
      mobilePrevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      mobileNextBtn.style.display = 'none';
    }

    if (window.innerWidth >= 1200) scrollAmount = 900;
    else if (window.innerWidth >= 870) scrollAmount = 700;
    else if (window.innerWidth >= 530) scrollAmount = 400;
    else scrollAmount = 200;
  }

  new ResizeObserver(widthChange).observe(slider);
  widthChange();

  slider.addEventListener('scroll', function (e) {
    const el = e.currentTarget;
    if (el.scrollLeft === 0) {
      prevBtn.style.opacity = 0;
      mobilePrevBtn.style.opacity = 0;
      nextBtn.style.opacity = 1;
      mobileNextBtn.style.opacity = 1;
    } else if (el.scrollWidth - el.clientWidth - 100 - el.scrollLeft < 0) {
      prevBtn.style.opacity = 1;
      mobilePrevBtn.style.opacity = 1;
      nextBtn.style.opacity = 0;
      mobileNextBtn.style.opacity = 0;
    } else {
      prevBtn.style.opacity = 1;
      mobilePrevBtn.style.opacity = 1;
      nextBtn.style.opacity = 1;
      mobileNextBtn.style.opacity = 1;
    }
  });

  prevBtn.addEventListener('click', function () {
    slider.scroll({ left: slider.scrollLeft - scrollAmount, behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function () {
    slider.scroll({ left: slider.scrollLeft + scrollAmount, behavior: 'smooth' });
  });
  mobilePrevBtn.addEventListener('click', function () {
    slider.scroll({ left: slider.scrollLeft - scrollAmount, behavior: 'smooth' });
  });
  mobileNextBtn.addEventListener('click', function () {
    slider.scroll({ left: slider.scrollLeft + scrollAmount, behavior: 'smooth' });
  });
})();
